import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./delivery.module.scss";
import { shortCurrency } from "../../../utils/currency";

const getPostfix = (value) => {
  return value === 1 || (value > 20 && (value + ``).slice(-1) === `1`)
    ? `дня`
    : `дней`;
};

function DeliveryList({items, isMoscow, currency}) {
  return (
    <>
      {typeof items === `string` ? (
        items
      ) : (
        <div className={styles.table}>
          {items.express && items.express.printio && (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Курьером
              </div>
              <div className={styles.cell}>
                От {items.express.printio.min_delivery_term}
                {` `}
                {getPostfix(items.express.printio.min_delivery_term)}
              </div>
              <div className={styles.cell}>
                {items.express.printio.cost}
                {shortCurrency(currency, items.express.printio.cost)}
              </div>
            </div>
          )}
          {Object.keys(items.pickup).length ? (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Пункт выдачи
              </div>
              <div className={styles.cell}>
                От {Math.min(...items.pickup.min_terms)}
                {` `}
                {getPostfix(Math.min(...items.pickup.min_terms))}
              </div>
              <div className={styles.cell}>
                от {Math.min(...items.pickup.costs)}
                {shortCurrency(currency, Math.min(...items.pickup.costs))}
              </div>
            </div>
          ) : null}
          {isMoscow ? (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Самовывоз с Малой Семёновской
              </div>
              <div className={styles.cell}>от 1 дня</div>
              <div className={styles.cell}>0{shortCurrency(currency, 0)}</div>
            </div>
          ) : null}
          {items.lightning && (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Молния
              </div>
              <div className={styles.cell}>Сегодня</div>
              <div className={styles.cell}>
                {items.lightning.cost}
                {shortCurrency(currency, items.lightning.cost)}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

DeliveryList.propTypes = {
  items: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isMoscow: PropTypes.bool
};

const mapStateToProps = (state) => ({
  currency: state.currency
})

export default connect(mapStateToProps)(DeliveryList);
